import * as React from "react"
import { Link } from "@zestia/gatsby-plugin-react-i18next"
import { gtmTracking } from "@/utils/gtm-tracking"

const SplitPaneSecondaryContent = ({
  divider,
  secondaryHeading,
  secondaryParagraph,
  paragraphClass = "mb-8 p--lg",
  children,
  link,
  linkClass = "text-link",
}) => {
  return (
    <div>
      {divider && <hr className="divider w40 mt-4 mb-8" />}
      {children && children}
      {secondaryHeading && <h3 className="h5">{secondaryHeading}</h3>}
      {secondaryParagraph && (
        <p className={`${paragraphClass}`}>{secondaryParagraph}</p>
      )}
      {link && (
        <Link
          className={linkClass}
          to={`${link.url}`}
          onClick={() => gtmTracking("Link Click", link.text, "Split Pane")()}
        >
          <b>{link.text}</b>
        </Link>
      )}
    </div>
  )
}

export default SplitPaneSecondaryContent
